module.exports = __webpack_public_path__ + "img/ruler-line-break.606950b7.png";